import classNames from "classnames"

const Checkmark = () => (
  <svg viewBox="0 0 12 12" className="h-3 w-3" aria-hidden="true">
    <path
      d="M2.5 6.2l2.4 2.4 4.6-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

type CheckboxOptionProps = {
  label: string
  checked: boolean
  onChange: () => void
  className?: string
}

const CheckboxOption = ({
  label,
  checked,
  onChange,
  className
}: CheckboxOptionProps) => (
  <label
    className={classNames(
      "flex min-h-8 cursor-pointer items-center gap-2 border-[0.5px] border-[#4B5563] px-2.5 py-2 text-xs leading-4 tracking-[-0.01em] dark:bg-[#1A1D21]",
      className
    )}
  >
    <input
      type="checkbox"
      className="sr-only"
      checked={checked}
      onChange={onChange}
    />
    <span
      className={classNames(
        "flex h-4 w-4 shrink-0 items-center justify-center border-[0.5px]",
        checked ? "border-stears_white text-stears_white" : "border-[#4B5563]"
      )}
    >
      {checked ? <Checkmark /> : null}
    </span>
    <span className={checked ? "dark:text-stears_white" : "text-[#9CA3AF]"}>
      {label}
    </span>
  </label>
)

export default CheckboxOption
